const fieldOptions = [
    { label: 'String', value: 'text' },
    { label: 'Number', value: 'int' },
    { label: 'Boolean', value: 'boolean' },
    { label: 'Password', value: 'password' },
    { label: 'Email', value: 'email' },
];

export default fieldOptions;
